import {Area} from "react-easy-crop";
import {SizesInterface} from "../../../types/Sizes";

export const getCroppedImage = (cropImageArea: HTMLImageElement, cropped: Area, sizes: SizesInterface) => {

    const canvas = document.createElement("canvas");

    canvas.width = sizes.maxWidth;
    canvas.height = sizes.maxHeight;

    const ctx = canvas.getContext("2d");
    if (ctx === null)
        return null;

    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(
        cropImageArea,
        cropped.x,
        cropped.y,
        cropped.width,
        cropped.height,
        0,
        0,
        canvas.width,
        canvas.height
    );

    return canvas.toDataURL("image/png", 1);
}
